module.exports = __webpack_public_path__ + "img/T6-A-xs_2.b1e8af7f.png";